import React from 'react'
import { IconBase, OptionalIconBaseProps } from '../components/IconBase'

export const ArrowRightIcon = (props: OptionalIconBaseProps) => (
  <IconBase name="arrow-right" viewBox="0 0 20 20" {...props}>
    <path d="M13.107 3.69289C12.7165 3.30236 12.0833 3.30236 11.6928 3.69289C11.3023 4.08341 11.3023 4.71658 11.6928 5.1071L15.5857 9.00001H2C1.44772 9.00001 1 9.44772 1 10C1 10.5523 1.44772 11 2 11H15.5857L11.6928 14.8929C11.3023 15.2834 11.3023 15.9166 11.6928 16.3071C12.0833 16.6977 12.7165 16.6977 13.107 16.3071L18.6977 10.7165C18.8842 10.5348 19 10.2809 19 10C19 9.71906 18.8842 9.46517 18.6976 9.28351L13.107 3.69289Z" />
  </IconBase>
)
